const SANITY_PROJECT_ID = process.env.GATSBY_SANITY_PROJECT_ID;
const SANITY_DATASET = process.env.GATSBY_SANITY_DATASET;

export const getSanityMediaUrl = (media) => {
    if (!media) return null;

    if (typeof media === 'string') {
        return media;
    }

    // This function now handles both 'file-' and 'image-' prefixes
    function formatSanityRef(ref) {
        return ref
            .replace(/^(image|file)-/, '')   // Remove the 'image-' or 'file-' prefix
            .replace(/-([^-]+)$/, '.$1');    // Replace the last hyphen with a dot
    }

    const ref = media.asset?._ref || media.asset?._id;
    if (!ref) return null;

    if (media._type === "file") {
        return `https://cdn.sanity.io/files/${SANITY_PROJECT_ID}/${SANITY_DATASET}/${formatSanityRef(ref)}`;
    }

    if (media._type === "image" || media._type === "customImageNoURL") {
        return `https://cdn.sanity.io/images/${SANITY_PROJECT_ID}/${SANITY_DATASET}/${formatSanityRef(ref)}`;
    }

    return null;
}